import React from 'react';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import TrustSignals from './components/TrustSignals';

const Register = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Main Container */}
      <div className="flex flex-col lg:flex-row min-h-screen">
        {/* Left Side - Registration Form */}
        <div className="flex-1 flex flex-col justify-center px-6 py-12 lg:px-8">
          <div className="w-full max-w-md mx-auto space-y-8">
            <RegistrationHeader />
            <RegistrationForm />
          </div>
        </div>

        {/* Right Side - Trust Signals & Information */}
        <div className="lg:w-96 bg-muted/30 border-l border-border px-6 py-12 lg:px-8">
          <div className="max-w-sm mx-auto lg:max-w-none">
            <TrustSignals />
          </div>
        </div>
      </div>
      {/* Mobile Bottom Section */}
      <div className="lg:hidden px-6 py-8 bg-muted/30 border-t border-border">
        <div className="max-w-md mx-auto">
          <TrustSignals />
        </div>
      </div>
      {/* Footer */}
      <footer className="bg-card border-t border-border px-6 py-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between space-y-2 sm:space-y-0">
          <p className="text-sm text-muted-foreground">
            © {new Date()?.getFullYear()} PenGame Publishing. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="/help" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Help Center
            </a>
            <a href="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Contact Support
            </a>
            <a href="/status" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              System Status
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Register;